import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { ChangeEvent, useState, useEffect } from 'react';
import { useForm, useFormContext } from 'react-hook-form';

import { FormControl, FormField, FormLabel, FormItem } from '@/components/shadcn/ui/form';
import { Table, TableBody, TableCell, TableFooter, TableHead, TableHeader } from '@/components/shadcn/ui/table';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/shadcn/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/ui/popover';
import { Button } from '@/components/shadcn/ui/button';
import { Input } from '@/components/shadcn/ui/input';
import React from 'react';
import { cn } from '@/lib/utils';
import { Check, ChevronsUpDown, Equal, Minus, PenIcon, PlusIcon, Trash2Icon, Plus, X } from 'lucide-react';
// import CustomInputCurrencyMask from '@/utils/customInputCurrencyMask';
import produtonegocio from '@/validations/schemas/produtonegocio';
import { useProduct } from '@/hook/useProduct';
import { useProductWithBusiness } from '@/hook/useProductWithBusiness';
import { useParams } from 'react-router-dom';
import { ProductWithBusinessToList, UpdateProductWithBusiness } from '@/entities/businessProduct';
import EditProductForm from './EditProductDialog';
import { useProductWithBusinessContext } from './ProductWithBusinessContext';
import CustomInputCurrencyMask from '@/utils/customInputCurrencyMask';
import DeleteDialog from './DeleteProductWithBusinessDialog';
import { useBusinessDetailContext } from '@/context/BusinessDetailContext';
import { useAuthContext } from '@/context/AuthContext';
import { useBusiness } from '@/hook/useBusiness';
import { toast } from '@/components/shadcn/ui/use-toast';
import { useSellers } from '@/hook/useSellers';
import { useBusinessSeller } from '@/hook/useBusinessSeller';
import { Seller } from '@/entities/seller';

// const currencyInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//   const { value } = e.target;
//   e.target.value = CustomInputCurrencyMask.valor(value);
// };

// const products = [
//   { label: 'Produto A', value: 'a', comission: '10%' },
//   { label: 'Produto B', value: 'b', comission: '11%' },
//   { label: 'Produto C', value: 'c', comission: '12%' },
//   { label: 'Produto D', value: 'd', comission: '13%' },
//   { label: 'Produto E', value: 'e', comission: '14%' },
//   { label: 'Produto F', value: 'f', comission: '15%' },
//   { label: 'Produto G', value: 'g', comission: '9%' },
//   { label: 'Produto H', value: 'h', comission: '8%'},
//   { label: 'Produto I', value: 'i', comission: '5%' },
// ] as const;

const ProductLev = () => {
  const { control, getValues, setValue } = useFormContext();
  const [quantity, setQuantity] = useState<number>(1);
  const [unitPrice, setUnitPrice] = useState(0);
  const [deploy, setDeploy] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(false);
  const [openV,setOpenV] = useState(false);
  const [indexEdited, setIndexEdited] = useState<number>(99999);
  const [totalDeploy,setTotalDeploy] = useState(0);
  const [totalMensal,setTotalMensal] = useState(0);
  // const [selectedProducts, setSelectedProducts] = useState<ProductWithBusinessToList[]>([]);
  const { productsUse } = useProduct();
  const { seller } = useSellers();
  const { productsBusiness, productsWithBusiness, createOrUpdateProductWithBusiness, createBusinessProduct, updateBusinessProduct, fetchBusinessProductWithId, deleteBusinessProduct } = useProductWithBusiness();
  const [productSelected, setProductSelected] = useState<any>();
  const { business, businessEdit, businessEdit2, setBusinessEdit2, setBusinessEdit, fetchbusinessById, setbusiness } = useBusinessDetailContext();
  const { leadId } = useParams<{ leadId: string }>();
  const leadId2Set = Number(leadId);
  const { upsertBusinessSeller, fetchBusinessSellers, businessSellers }= useBusinessSeller(leadId2Set);
  const [sellerdata,setSellerdata] = useState<Seller>();
  const { business2 } = useBusiness(leadId2Set);
  const { accessToken } = useAuthContext();
  const { openEdit, product2Edit, selectedProducts, deleteOpen, setDeleteOpen, setSelectedProducts, setProduct2Edit, setOpenEdit } = useProductWithBusinessContext();
  const [check, setCheck] = useState(false);
  const calculateTotal = (quantity: number, unitPrice: number, discount: number, deploy: number): number => {
    if (check != false) { return (quantity * unitPrice) - discount + deploy }
    else {
      return (quantity * unitPrice) - discount
    }
  };

  const loadData = async () => {
  const data =  await fetchBusinessSellers(leadId2Set);
  setValue('codVend', data ? data.SellerId : getValues().id)
  }

  useEffect(() => {
    fetchBusinessProductWithId(leadId2Set);
    const pWithB = productsWithBusiness.map((p: ProductWithBusinessToList) => ({
      businessId: p.businessId,
      discount: p.discount,
      // eslint-disable-next-line
      commission: productsUse.find((prod) => { p.productId === prod.id })?.commission ? productsUse.find((prod) => { p.productId === prod.id })?.commission : 0,
      id: p.id,
      price: p.price,
      deploy: p.deploy,
      productId: p.productId,
      quantity: p.quantity,
      total: p.total,
      product: p.product,
      businessSellers: p.businessSellers,
    }));
    loadData();
    setSelectedProducts(pWithB);
    setValue('client', businessEdit2 ? businessEdit2.client : getValues().client);
    setValue('descricao', businessEdit2 ? businessEdit2.descricao : getValues().descricao);
    setValue('dtinicio', businessEdit2 ? businessEdit2.dtinicio : getValues().startedAt);
    setValue('tel', businessEdit2 ? businessEdit2.tel : getValues().tel);
    setValue('situacao', businessEdit2 ? businessEdit2.situacao : getValues().situacao);
    setValue('previsao', businessEdit2 ? businessEdit2.previsao : getValues().previsao);
    setValue('idfontenegocio', businessEdit2 ? businessEdit2.idfontenegocio : getValues().idfontenegocio);
    setValue('observation', businessEdit2 ? businessEdit2.observation : getValues().observation);
    setValue('idtiponegocio', businessEdit2 ? businessEdit2.idtiponegocio : getValues().idtiponegocio);
    setValue('observacao', businessEdit2 ? businessEdit2.idtiponegocio : getValues().observacao);
    setValue('deploy', businessEdit2 ? businessEdit2.deploy : getValues().deploy);

  }, []);

  useEffect(() => {
    const pWithB = productsWithBusiness.map((p: ProductWithBusinessToList) => ({
      businessId: p.businessId,
      discount: p.discount,
      // eslint-disable-next-line
      commission: productsUse.find((prod) => p.productId === prod.id)?.commission ? productsUse.find((prod) => p.productId === prod.id)?.commission : 0,
      id: p.id,
      price: p.price,
      deploy: p.deploy,
      productId: p.productId,
      quantity: p.quantity,
      total: p.total,
      product: p.product,
    }));
    setSelectedProducts(pWithB);
    if(selectedProducts?.length > 0) {
      const pricetotal = selectedProducts.reduce((soma: any, produto: { price: any; }) => soma + produto.price, 0);
      const deploytotal = selectedProducts.reduce((soma: any, produto: { deploy: any; }) => soma + produto.deploy, 0);
      setTotalDeploy(deploytotal);
      setTotalMensal(pricetotal);
    }
    if(selectedProducts?.length == 0) {
      setTotalDeploy(0);
      setTotalMensal(0);
    }
  }, [productsWithBusiness]);


  useEffect(() => {
    setTotal(calculateTotal(quantity, unitPrice, discount, deploy));
    setValue('totalprod', total.toString());
  }, [quantity, unitPrice, discount, deploy, check]);

  const changedQuantity = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value) || 0;
    setQuantity(newValue);
  };

  const handleUpsert = async (businessId: number, sellerId: number) => {
    const dado = await upsertBusinessSeller(businessId,sellerId);
    if(dado){
      toast({description:'Vendedor Inserido Com Sucesso'});
    } else {
      toast({description: 'Algum erro aconteceu', variant: 'destructive'})
    }
  }

  const handleProductEdit = (data: any) => {
    const listEdit = [...selectedProducts];
    listEdit[indexEdited].quantity = Number(data.quantity);
    listEdit[indexEdited].price = Number(data.price);
    listEdit[indexEdited].discount = Number(data.discount);
    listEdit[indexEdited].total = Number(data.total);
    listEdit[indexEdited].deploy = Number(data.deploy);
    if (check) {
      setDeploy(data.deploy);
    } else {
      setDeploy(0);
    }
    const dataForEdit = {
      id: Number(data.id),
      quantity: Number(data.quantity),
      price: Number(data.price),
      discount: Number(data.discount),
      total: Number(data.total),
      deploy: Number(deploy),
      businessId: leadId2Set,
      productId: Number(data.productId)
    };
    if (dataForEdit.id) {
      updateBusinessProduct(dataForEdit);
    }
    setSelectedProducts(listEdit);
  };
  const changedDiscount = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value) || 0;
    setDiscount(newValue);
    setValue('desconto', newValue);
  };

  const changedDeploy = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value) || 0;
    setDeploy(newValue);
    setValue('deploy', newValue);
  };

  const changedUnitPrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value) || 0;
    // e.target.value = CustomInputCurrencyMask.valor(e.target.value);
    setUnitPrice(newValue);
  };

  const handleProductDelete = (index: number) => {
    const listProducts = [...selectedProducts];
    if (listProducts[index].id) {
      deleteBusinessProduct(listProducts[index].id);
    }
    listProducts.splice(index, 1);
    setSelectedProducts(listProducts);
  };

  const form = useForm<z.infer<typeof produtonegocio>>({
    resolver: zodResolver(produtonegocio),
  });

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formValues = getValues();

    // Verifica se algum campo está vazio
    const hasEmptyFields = Object.values(formValues).some(value => {
      return value === "" || value === null || value === undefined;
    });

    if (hasEmptyFields) {
      toast({ title: "Preencha todos os campos antes de continuar!", variant: "destructive" });
      return;
    }

  };


  return (
    <div className='flex justify-center items-start h-full min-h-max'>
      <div className='flex flex-col justify-center items-center min-h-max border-black-50 border-2 bg-white rounded-lg w-2/3'>
        <form onSubmit={handleSubmit} className='py-2 px-2 flex flex-col gap-4'>
          {/** Produtos */}
          <FormField
            control={control}
            name='codVend'
            render={({ field }) => (
              <FormItem className='flex flex-col w-2/3'>
                <FormLabel className='text-slate-900 pb-2.5'>Vendedor</FormLabel>
                <Popover open={openV} onOpenChange={setOpenV}>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button

                        aria-expanded={openV}
                        variant='outline'
                        role='combobox'
                        className={cn('w-full h-10 justify-between bg-slate-50 focus:bg-white text-muted-foreground font-normal',
                          !field.value && 'text-muted-foreground font-normal'
                        )}>
                        {field.value
                          ? seller.find(
                            (product) => product.id === field.value
                          )?.name
                          : 'Selecione o vendedor'
                        }
                        <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className='w-inherit p-0'>
                    <Command>
                      <CommandInput placeholder='Procure um produto' />
                      <CommandEmpty>Não encontrado</CommandEmpty>
                      <CommandList>
                        <CommandGroup>
                          {seller.map((product) => (
                            <CommandItem
                              value={product.name}
                              key={product.id}
                              onSelect={() => {
                                setValue('codVend', product.id);
                                handleUpsert(leadId2Set,product.id);
                                setOpenV(false);
                              }}
                            >
                              <Check
                                className={cn('mr-2 h-4 w-4',
                                  product.id === field.value
                                    ? 'opacity-100'
                                    : 'opacity-0'
                                )}
                              />
                              <span>{product.name}</span>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
              </FormItem>
            )}
          />

          <FormField 
          control={control}
          name='codprod'
          render={({ field }) => (
            <FormItem>
              <FormLabel className='text-slate-900 pb-2.5'>Produto</FormLabel>
                <Popover open={open} onOpenChange={setOpen}>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button

                        aria-expanded={open}
                        variant='outline'
                        role='combobox'
                        className={cn('w-full h-10 justify-between bg-slate-50 focus:bg-white text-muted-foreground font-normal',
                          !field.value && 'text-muted-foreground font-normal'
                        )}>
                        {field.value
                          ? productsUse.find(
                            (product) => product.id === field.value
                          )?.name
                          : 'Selecione um produto'
                        }
                        <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <label>
                    <input
                      type="checkbox"
                      checked={check}
                      onChange={() => setCheck(!check)}
                    />
                    Usar Valor de implantação
                  </label>
                  <PopoverContent className='w-inherit p-0'>
                    <Command>
                      <CommandInput placeholder='Procure um produto' />
                      <CommandEmpty>Não encontrado</CommandEmpty>
                      <CommandList>
                        <CommandGroup>
                          {productsUse.map((product) => (
                            <CommandItem
                              value={product.name}
                              key={product.id}
                              onSelect={() => {
                                setValue('codprod', product.id);
                                setValue('valor', product.price);
                                setValue('deploy', product.deploy);
                                setOpen(false);
                                setProductSelected(product);
                                setUnitPrice(product.price);
                                setDeploy(Number(product.deploy));
                              }}
                            >
                              <Check
                                className={cn('mr-2 h-4 w-4',
                                  product.id === field.value
                                    ? 'opacity-100'
                                    : 'opacity-0'
                                )}
                              />
                              <span>{product.name}</span>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
            </FormItem>
          )}
          />

          <div className='flex items-start gap-2'>
            {/** Quantidade de Produto */}
            <FormField
              control={control}
              name='quantidade'
              render={({ field }) => (
                <FormItem className='flex flex-col w-1/3'>
                  <FormLabel className='text-slate-900 pb-2.5'>Quantidade</FormLabel>
                  <FormControl>
                    <Input
                      value={quantity}
                      className='bg-slate-50 text-muted-foreground text-center text-sm focus:bg-slate-100 focus:outline-none focus:ring-0 hover:bg-slate-100 caret-invisible'
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        changedQuantity(e);
                        setValue('quantidade', Number(e.target.value) || 0);
                        setQuantity(Number(e.target.value) || 0);
                        field.onChange(e);
                      }}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <X size={16} className='mt-6 self-center' />

            {/** Valor Unitário */}
            <FormField
              control={control}
              name='valor'
              render={({ field }) => (
                <FormItem className='flex flex-col w-1/2'>
                  <FormLabel className='text-slate-900 pb-2.5'>Valor Unitário</FormLabel>
                  <FormControl>
                    <Input
                      value={unitPrice}
                      placeholder="R$"
                      className='bg-slate-50 text-muted-foreground hover:bg-slate-100 hover:placeholder:text-slate-900 hover:text-slate-900 focus:bg-white'
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        changedUnitPrice(e);
                        field.onChange(e);
                      }} />
                  </FormControl>
                </FormItem>
              )}
            />
            <Minus size={16} className='mt-6 self-center' />

            {/** Desconto */}
            <FormField
              control={control}
              name='desconto'
              render={({ field }) => (
                <FormItem className='flex flex-col w-1/2'>
                  <FormLabel className='text-slate-900 pb-2.5'>Desconto</FormLabel>
                  <FormControl>
                    <Input
                      value={discount}
                      placeholder="R$"
                      className='bg-slate-50 text-muted-foreground hover:bg-slate-100 hover:placeholder:text-slate-900 hover:text-slate-900 focus:bg-white'
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        // currencyInputChange(e);
                        changedDiscount(e);
                        setValue('desconto', Number(e.target.value) || 0);
                        field.onChange(e);
                      }} />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>


          <div className='flex items-center justify-end gap-2'>
            <Plus size={16} className='mt-6 self-center' />
            {check && <FormField
              control={control}
              name='deploy'
              render={({ field }) => (
                <FormItem className='flex flex-col w-1/3 self-end'>
                  <FormLabel className='text-slate-900 pb-2.5'>Valor implantação</FormLabel>
                  <FormControl>
                    <Input
                      value={Number(deploy)}
                      placeholder='R$'
                      className='bg-slate-50 text-slate-900 hover:bg-slate-100 hover:placeholder:text-slate-900 hover:text-slate-900 focus:bg-white'
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        changedDeploy(e);
                        field.onChange(e);
                      }} />
                  </FormControl>
                </FormItem>
              )}
            />}
            <Equal size={16} className='mt-6 self-center' />
            {/** Total */}
            <FormField
              control={control}
              name='totalprod'
              render={({ field }) => (
                <FormItem className='flex flex-col w-1/3 self-end'>
                  <FormLabel className='text-slate-900 pb-2.5'>Total</FormLabel>
                  <FormControl>
                    <Input
                      value={total}
                      placeholder='R$'
                      className='bg-slate-50 text-slate-900 hover:bg-slate-100 hover:placeholder:text-slate-900 hover:text-slate-900 focus:bg-white'
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        field.onChange(e);
                      }} />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
          <Button

            type='button'
            onClick={(e) => {
              e.preventDefault();
              const formData = getValues();
              // console.log(discount);
              // console.log(formData.valor);
              const selectedProduct = productsUse.find((product) => product.id === formData.codprod);
              if (selectedProduct) {
                if (discount < formData.valor) {
                  const newProduct = {
                    id: 0,
                    commission: selectedProduct.commission,
                    quantity: Number(quantity),
                    price: Number(formData.valor),
                    discount: Number(formData.desconto) || 0,
                    total: calculateTotal(Number(quantity), Number(unitPrice), Number(discount), Number(deploy)),
                    businessId: leadId2Set,
                    productId: selectedProduct.id,
                    product: { name: selectedProduct.name },
                    deploy: check ? Number(formData.deploy) : 0,
                  };
                  
                  const updatedProducts = [...selectedProducts, newProduct];

                  const sumDeploy = updatedProducts.reduce((acc, item) => acc + item.deploy, 0);
                  const sumPrice = updatedProducts.reduce((acc, item) => acc + item.price, 0);

                  setSelectedProducts(updatedProducts);
                  setTotalMensal(sumPrice);
                  setTotalDeploy(sumDeploy);
                  setQuantity(1);
                  setDiscount(0);
                  setValue('codprod', 0);
                } else
                  toast({ description: 'Valor de desconto acima do valor de custo!', variant: 'destructive' })
                // setUnitPrice(0);
              }
            }}
            className='bg-green-200 hover:bg-green-300 w-10 self-end'><PlusIcon size={16} color='gray' /></Button>
        </form>
        <div className='border rounded-md my-2'>
          <Table>
            <TableHeader className='border-b text-xs'>
              <TableHead>Produto</TableHead>
              <TableHead>Comissão</TableHead>
              <TableHead>Quantidade</TableHead>
              <TableHead>Unitário</TableHead>
              <TableHead>Desconto</TableHead>
              <TableHead>Vlr Implant</TableHead>
              <TableHead></TableHead>
            </TableHeader>
            <TableBody className='text-xs'>
              {selectedProducts.map((product: any, index: number) => (
                <tr key={index}>
                  <TableCell className='border-gray-600 border-r-2'>{product.product.name}</TableCell>
                  <TableCell className='border-gray-600 border-r-2'>{product.commission}%</TableCell>
                  <TableCell className='border-gray-600 border-r-2'>{product.quantity}</TableCell>
                  <TableCell className='border-gray-600 border-r-2'>R$ {product.price.toFixed(2)}</TableCell>
                  <TableCell className='border-gray-600 border-r-2'>R$ {product.discount.toFixed(2)}</TableCell>
                  <TableCell className='border-gray-600 border-r-2'>R$ {product.deploy.toFixed(2)}</TableCell>
                  <TableCell>
                    <Button variant='ghost' onClick={() => {
                      setOpenEdit(true);
                      setIndexEdited(index);
                      setProduct2Edit(product);
                    }}>
                      <PenIcon size={12} />
                    </Button>
                    <Button variant='ghost' onClick={() => {
                      setIndexEdited(index);
                      setDeleteOpen(true);
                    }}>
                      <Trash2Icon size={12} />
                    </Button>
                  </TableCell>
                </tr>
              ))}
            </TableBody>
            <TableFooter className='text-xs font-bold'>
              <TableCell colSpan={5}></TableCell>
              <TableCell className='text-right'>Total Implantação:</TableCell>
              <TableCell>R$ {totalDeploy.toFixed(2)}</TableCell>
              <TableCell></TableCell>
            </TableFooter>
            <TableFooter className='text-xs font-bold'>
              <TableCell colSpan={5}></TableCell>
              <TableCell className='text-right'>Total Mensalidade:</TableCell>
              <TableCell>R$ {totalMensal.toFixed(2)}</TableCell>
              <TableCell></TableCell>
            </TableFooter>
          </Table>
        </div>

        <Button onClick={(e) => {
          e.preventDefault();
          selectedProducts.forEach((p: any) => {
            createOrUpdateProductWithBusiness(p);
          });
          if (selectedProducts.length === 0) {
            toast({ title: 'Adicione algum produto ao negócio para continuar', variant: 'destructive' });
          } else {
            toast({ title: 'Atualização realizada com sucesso' });
          }

        }} type='submit' variant='outline' className=" text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Salvar alterações</Button>
        <EditProductForm onProductUpdateSubmit={handleProductEdit} />
        <DeleteDialog handleDelete={() => { handleProductDelete(indexEdited); }} />
      </div>
    </div>
  );
};

export default ProductLev;
